import { Payment } from '@apply/api/src/api/PaymentApi';
import { TimelineEntry } from './TimelineEntry';

interface TimelineSectionParameters {
    payment: Payment;
}

export const TimelineSection: React.FC<TimelineSectionParameters> = ({ payment }) => {
    return (
        <>
            <div className='payment-edit-section'>Timeline</div>
            <div className='payment-edit-timeline'>
                {(payment.histories ?? []).map((h) => (
                    <TimelineEntry {...h} />
                ))}
            </div>
        </>
    );
};
